import { render, staticRenderFns } from "./MaintenanceFleetDetail.vue?vue&type=template&id=81f32cf2&scoped=true"
import script from "./MaintenanceFleetDetail.vue?vue&type=script&lang=js"
export * from "./MaintenanceFleetDetail.vue?vue&type=script&lang=js"
import style0 from "./MaintenanceFleetDetail.vue?vue&type=style&index=0&id=81f32cf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f32cf2",
  null
  
)

export default component.exports